// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.travel-offers-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 48px;
}

.travel-offers-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.travel-offers-subtitle {
  color: #666;
  margin-bottom: 24px;
}

.travel-offers-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.travel-offers-filters input,
.travel-offers-filters select {
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #dde2eb;
  min-width: 200px;
  font-size: 14px;
}

.travel-offers-refresh {
  padding: 8px 14px;
  border-radius: 999px;
  border: none;
  background: #111827;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.travel-offers-refresh:disabled {
  opacity: 0.6;
  cursor: default;
}

.travel-offers-status {
  margin: 16px 0;
  color: #444;
}

.travel-offers-status.error {
  color: #c0392b;
}

.travel-offers-grid-wrapper {
  max-height: calc(100vh - 360px);
  overflow-y: auto;
  padding-right: 4px;
}

.travel-offers-manual {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.manual-label {
  display: block;
  font-size: 13px;
  color: #4b5563;
  margin-bottom: 8px;
}

.manual-textarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  font-size: 13px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New",
    monospace;
  resize: vertical;
  min-height: 50px;
}

.manual-textarea:focus {
  outline: none;
  border-color: #0f62fe;
  box-shadow: 0 0 0 1px rgba(15, 98, 254, 0.15);
}

.manual-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.travel-offers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.travel-offer-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 16px 14px;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
  border: 1px solid #edf0f5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.travel-offer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.badge-airline {
  background: #e6f2ff;
  color: #1f6feb;
}

.badge-hotel {
  background: #e9f8f1;
  color: #1c7c54;
}

.badge-other {
  background: #f3f4f6;
  color: #4b5563;
}

.badge-cashback {
  background: #fff7e6;
  color: #b9770e;
}

.badge-discount {
  background: #e9f5ff;
  color: #0f62fe;
}

.badge-other.badge-other {
  /* keep generic styling */
}

.travel-offer-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.travel-offer-merchant {
  font-size: 13px;
  color: #6b7280;
}

.travel-offer-section {
  margin-top: 4px;
}

.travel-offer-section .label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  margin-bottom: 2px;
}

.pill-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pill-list li {
  padding: 3px 8px;
  border-radius: 999px;
  background: #f3f4ff;
  color: #374151;
  font-size: 11px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mono {
  font-family: 
    ui-monospace, 
    SFMono-Regular, 
    Menlo, 
    Monaco, 
    Consolas, 
    "Liberation Mono", 
    "Courier New",
    monospace;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.small {
  font-size: 12px;
  line-height: 1.4;
}

.travel-offer-footer {
  margin-top: 4px;
  display: flex;
  justify-content: flex-end;
}

.travel-offer-footer a {
  font-size: 12px;
  color: #0f62fe;
  text-decoration: none;
}

.travel-offer-footer a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .travel-offers-page {
    padding: 20px 16px 32px;
  }

  .travel-offers-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/views/TravelOffersView.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;aACW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;;;;;;;;aAQW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".travel-offers-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 24px 48px;\n}\n\n.travel-offers-title {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.travel-offers-subtitle {\n  color: #666;\n  margin-bottom: 24px;\n}\n\n.travel-offers-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.travel-offers-filters input,\n.travel-offers-filters select {\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #dde2eb;\n  min-width: 200px;\n  font-size: 14px;\n}\n\n.travel-offers-refresh {\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: none;\n  background: #111827;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.travel-offers-refresh:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.travel-offers-status {\n  margin: 16px 0;\n  color: #444;\n}\n\n.travel-offers-status.error {\n  color: #c0392b;\n}\n\n.travel-offers-grid-wrapper {\n  max-height: calc(100vh - 360px);\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.travel-offers-manual {\n  margin-bottom: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n}\n\n.manual-label {\n  display: block;\n  font-size: 13px;\n  color: #4b5563;\n  margin-bottom: 8px;\n}\n\n.manual-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  padding: 10px 12px;\n  font-size: 13px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\",\n    monospace;\n  resize: vertical;\n  min-height: 50px;\n}\n\n.manual-textarea:focus {\n  outline: none;\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 1px rgba(15, 98, 254, 0.15);\n}\n\n.manual-actions {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.travel-offers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.travel-offer-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 16px 16px 14px;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);\n  border: 1px solid #edf0f5;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.travel-offer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.badge-airline {\n  background: #e6f2ff;\n  color: #1f6feb;\n}\n\n.badge-hotel {\n  background: #e9f8f1;\n  color: #1c7c54;\n}\n\n.badge-other {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.badge-cashback {\n  background: #fff7e6;\n  color: #b9770e;\n}\n\n.badge-discount {\n  background: #e9f5ff;\n  color: #0f62fe;\n}\n\n.badge-other.badge-other {\n  /* keep generic styling */\n}\n\n.travel-offer-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.travel-offer-merchant {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.travel-offer-section {\n  margin-top: 4px;\n}\n\n.travel-offer-section .label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n  margin-bottom: 2px;\n}\n\n.pill-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pill-list li {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f3f4ff;\n  color: #374151;\n  font-size: 11px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mono {\n  font-family: \n    ui-monospace, \n    SFMono-Regular, \n    Menlo, \n    Monaco, \n    Consolas, \n    \"Liberation Mono\", \n    \"Courier New\",\n    monospace;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.small {\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.travel-offer-footer {\n  margin-top: 4px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.travel-offer-footer a {\n  font-size: 12px;\n  color: #0f62fe;\n  text-decoration: none;\n}\n\n.travel-offer-footer a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .travel-offers-page {\n    padding: 20px 16px 32px;\n  }\n\n  .travel-offers-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
